import ParseImageCreator from "./ParseImageCreator";
import { useState } from 'react';
import A from './ActionCreators';
import G from './Getters';
import { useDispatch, useSelector } from 'react-redux';
import Id from './IdFactory';
import { FIGURE_PANELS } from './RecordTypes';
import CancelIcon from '@material-ui/icons/Cancel';
import Navbar from './Navbar';
import GelPanelSpecification from './GelPanelSpecification';
import MicroscopyPanelSpecification from './MicroscopyPanelSpecification';
import useNavbar from './useNavbar';

const WESTRN_BLOT_TYPE = "westernBlot";
const MICROSCOPY_PANEL_TYPE = "microscopy";

const options = [
  { _id:WESTRN_BLOT_TYPE, label:"Gel/Blot",  },
  { _id:MICROSCOPY_PANEL_TYPE, label:"Microscopy" },
  /*{ _id:"parseImage", label:"Recreate from Image" },*/
]

export default function NoFigureSelectedScene({setSelectedFigurePanelContext, setTargetDirectoryOfNewFigurePanel, targetDirectoryOfNewFigurePanel}){


  let [ figurePanelType, navbar, setFigurePanelType ] = useNavbar({options},options[0]._id)  
  let dispatch = useDispatch();

  //const [figurePanelType, setFigurePanelType] = useState(MICROSCOPY_PANEL_TYPE);
  let isGel = figurePanelType === WESTRN_BLOT_TYPE;
  let isMicroscopy = figurePanelType === MICROSCOPY_PANEL_TYPE;


  let panelSpecProps = {
        setSelectedFigurePanelContext, setTargetDirectoryOfNewFigurePanel, targetDirectoryOfNewFigurePanel
      }
  return (<>
    <div 
      containerType={"sceneContainer"}
      scene={"panelSpecification"}
      style={{
        textAlign:'center', 
        background:'white',//'#eee', 
        position:'relative',
      }} class="sg-col full-width">

      <div button="cancelFigureCreation" style={{
        position:'absolute',
        top:0, left:0, margin:10,
        cursor:'pointer'
      }}
        onClick={() => {
          setTargetDirectoryOfNewFigurePanel(false);
        }}
      >
        <CancelIcon />
      </div>

    <div style={{
      borderBottom:'1px solid #ccc',
        marginBottom:20,
    }} class="sg-row h-center">
    <div style={{marginBottom:20}}>
    <h4 style={{marginTop:50, marginBottom:20}}>Figure Type</h4>

      {navbar}

      {false && <select onChange={(e) => {
        setFigurePanelType(e.target.value);
      }} value={figurePanelType} style={{fontSize:18}}>
        {options.map(({_id,label}) => {
          return <option value={_id}>{label}</option>
        })}
      </select>}


      {false && <Navbar style={{fontSize:18}} options={options} spread={false} onSelect={setFigurePanelType} selected={figurePanelType} direction={"row"}/>}
    </div>
    </div>

      <div style={{
        //border:'1px solid blue',
        justifyContent:'center',
      }} class="sg-row ">

        

      {isGel && <GelPanelSpecification {...panelSpecProps}/>}
      {isMicroscopy && (
        <>
        {true && <MicroscopyPanelSpecification {...panelSpecProps}/>}
        </>
      )}
      {figurePanelType === "parseImage" && (
        <ParseImageCreator/>
      )}
    </div>

      
    </div> 
  </>)
}
